<div class="container py-5">
  <div class="row">
    <div class="col-lg-6 offset-lg-3">
      <rrs-auth [isAuthPage]="true"></rrs-auth>
    </div>
  </div>
</div>

<cx-page-slot position="below_form_content"></cx-page-slot>
